import { AppBox } from "../../../../../commons/components";
import { User } from "../../../../../commons/models/user";
import { toTitleCase } from "../../../../../commons/utilities/string-utils";

interface SubTeamCoachAddConfirmProps {
  user: User;
}
export default function SubTeamCoachAddConfirm({ user }: SubTeamCoachAddConfirmProps) {
  return (
    <AppBox displayBlock>
      Do you want to add <strong>“{toTitleCase(user.fullName)}” </strong> to the sub-team as coach?
    </AppBox>
  );
}
